import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mobile-search-title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseSearch = _resolveComponent("PulseSearch")
  const _component_Popover = _resolveComponent("Popover")

  return (_ctx.$responsive.mobile)
    ? (_openBlock(), _createBlock(_component_Popover, {
        key: 0,
        modelValue: $data.mobile_search_open,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.mobile_search_open) = $event)),
        width: "36.2rem",
        class: "feed-search mobile-search",
        persistent: false,
        "popper-class": "mobile-search-popover",
        placement: "bottom-start",
        offset: 8,
        mask: "",
        onShow: $options.focusMobileSearch
      }, {
        reference: _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass(["mobile-search-button pointer", {active: _ctx.value}]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = $event => ($data.mobile_search_open = !$data.mobile_search_open))
          }, [
            _createVNode(_component_Icon, {
              icon: "search-md",
              size: "1.6rem",
              stroke: "var(--gray-700)",
              "stroke-width": "1"
            })
          ], 2 /* CLASS */)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Search", -1 /* HOISTED */)),
            _createVNode(_component_Icon, {
              class: "pointer",
              icon: "x-close",
              size: "1.8rem",
              stroke: "var(--gray-500)",
              "stroke-width": "1",
              onClick: _cache[1] || (_cache[1] = $event => ($data.mobile_search_open = false))
            })
          ]),
          _createVNode(_component_PulseSearch, {
            ref: "mobile_search",
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.value) = $event)),
            loading: $props.loading,
            placeholder: "Search signals...",
            class: "mobile-search-input"
          }, null, 8 /* PROPS */, ["modelValue", "loading"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "onShow"]))
    : (_openBlock(), _createBlock(_component_PulseSearch, {
        key: 1,
        modelValue: _ctx.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.value) = $event)),
        loading: $props.loading,
        placeholder: "Search signals...",
        class: "feed-search search"
      }, null, 8 /* PROPS */, ["modelValue", "loading"]))
}